/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel
} from '../../common/controller/signal-admin-resource-api';

export interface ContextServiceConfigurationModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class ContextServiceConfigurationApiService
  extends SignalAdminResourceApiBase<ContextServiceConfigurationModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'contextserviceconfigurations');
  }
}
